export const m = {
    about: '약',
    Qualification: '자격',
    LegalDocument: '법률 문서',
    Partners: '파트너',
    ContactUs: '문의하기',
    Trade: '무역',
    IEO: 'IEO',
    OTC: 'OTC',
    News: '뉴스',
    Announcement: '발표',
    IndustryNews: '산업 뉴스',
    Assets: '자산',
    Personalcenter: '개인 센터',
    logout: '출구',
    login: '로그인',
    register: '레지스터',
    Exchange: '교환',
    LVOSubscribe: '구독',
    Notice: '주의',
    Tradingpair: '거래 쌍',
    Latestprice: '최신 가격',
    hChange: '24 시간 변경',
    hHigh: '24 시간 최고',
    hLow: '24 시간 최저',
    hVolume: '24 시간 거래량',
    Deal: '거래',
    gBlockchain: '글로벌 블록 체인 자산 거래 플랫폼',
    ReliableSystem: '안정적인 시스템',
    RelGuaranteestem: '거래의 안전하고 안정적이며 효율적인 운영을 보장합니다.',
    Elitewor: '세계 최고의 인재로 구성된 엘리트 팀.',
    Safetyfund: '자금의 안전',
    encryption: 'HTTPS 데이터 암호화, 신원 확인',
    encryptarchitectureion: 'Cold Wallet Storage, 재무 수준 아키텍처, 다중 보안 보호',
    eexperienceon: '최고의 경험',
    eeMultilingualn: '신속한 인출, 다국어',
    Highperformance: '고성능 거래 엔진, 빠른 거래 경험',
    Professionalservices: '전문적인 서비스',
    Professiinternational: '전문 국제 서비스 팀',
    problemsal: '사용자 문제에 적시에 대응',
    Anywhere: '무역. 어딘가에.',
    cryptocurrencye: 'Cornucopia의 암호 화폐 거래소의 모든 힘을 당신의 손 안에 있습니다. 오늘 풍요의 뿔 모바일 암호화 거래 앱을 다운로드하십시오.',
    cryTradingcye: '지금 거래 시작',
    Deposi: '예금',
    Help: '도움',
    Registernow: '지금 등록하세요',
    trading: "거래 를 시작 하 다",
    Beginnerguide: '초보자 가이드',
    FAQ: '자주하는 질문',
    FADigitalQ: '디지털 자산 소개',
    PrivacyPolicy: '개인 정보 정책',
    Disclaimer: '부인 성명',
    UserAgreement: '부인 성명',
    Mail: '우편',
    Address: '주소',
    Unitedsta: '미국 뉴욕',
    UniDigitaltedsta: '디지털 자산은 가격 변동성이 높고 투자 위험이 높은 혁신적인 투자 상품입니다. 투자하기 전에 디지털 자산을 충분히 인식하고 합리적으로 투자 능력을 판단하고 신중한 투자 결정을 내리십시오.',
    Risktips: '위험 팁',
    COMMITTED: '우리는 BOLCKCHAIN ​​프로젝트가 자금을 조달하여 후원자를 찾고 신선하고 흥미로운 좋은 아이디어를 만들 수 있도록 최선을 다하고 있습니다.',
    CURRENCY: '새로운 통화 러시',
    CURInformationNCY: 'LVO-토큰 정보',
    CURInformatiFVG: 'FVG-토큰 정보',
    CURInformatcvv: 'CVV-토큰 정보',
    Circulation: '순환',
    Liquidity: '유동성',
    Initialprice: '초기 가격',
    Lockcycle: '잠금주기',
    Deadline: '마감 시간',
    DeaSubscrip: '구독 카운트 다운',
    Subscribe: '구독',
    SessionTicket: 'LVO-USDT 구독이 진행 중입니다.',
    SOperatingt: 'LVO-DApp 기반 운영 체제',
    Price: '발행 가격 ',
    SessionSupply: '총 구독 금액',
    Sessipaper: '프로젝트 백서 다운로드',
    Requirements: '프로젝트 참여 조건',
    Reqcompleteents: '토큰 발급자의 요구 사항을 충족하려면 모든 사용자가 계정 확인을 완료해야합니다.',
    Pleaseents: '로그인 해주세요',
    ProjectIntroduction: '프로젝트 설명',
    Keyfeatures: '주요 특징',
    Purposeof: 'VCE의 목적',
    TOKENALLOCATION: '토큰 분배',
    TOKENSCHEDULE: '토큰 발행 일정',
    MyAssets: '내 자산',
    Withdrawhistory: '입금 및 출금 기록',
    SubscribeHistory: '구독 기록',
    Capitalflow: '자본 흐름',
    Deposit: '재충전',
    TotalAssets: '총 자산',
    Toconversionsets: '참고 : 총 자산 전환은 시장 견적을 기반으로 추정되며 사용자를위한 참고 용입니다.',
    SmallBalances: '작은 자산 통화 숨기기',
    Currency: '통화',
    Total: '합계',
    Available: '유효한',
    Frozen: '얼다',
    Description: '운영',
    Withdraw: '철수',
    WithdrawAddress: '출금 주소',
    WithdrawAmount: '인출 횟수',
    ServiceCharge: '서비스 요금',
    Amountarrival: '도착 수량',
    fundpwd: '펀드 비밀번호',
    Tips: '노트',
    minimum: '최소 인출수량은 다음과 같다',
    musuallyum: '인출은 일반적으로 완료하는 데 2 ​​~ 24 시간이 소요되며 도착시 이메일로 알려드립니다. 자금의 안전을 보장하기 위해 귀하의 계정 보안 정책 변경, 비밀번호 변경 또는 새 주소를 사용한 출금시 수동 검토를 수행합니다. 인내심을 갖고 직원이 전화 나 이메일을 통해 연락 할 때까지 기다리십시오.',
    muconfirmyum: '• 정보가 변경되거나 유출되지 않도록 컴퓨터와 브라우저의 보안을 확인하십시오.',
    forbiddenum: '• GC 마켓 플랫폼 내 계정 간 코인 입출금은 금지되어 있으며, 필요시 이체 작업이 가능합니다.',
    DepositAddress: '입금 주소',
    Copy: '부',
    blockchainCopy: '나는 충전했다',
    confirmnCopy: '정보가 변경되거나 유출되지 않도록 컴퓨터와 브라우저의 보안을 확인하십시오.',
    forbidden: 'GC 마켓 플랫폼 내 계정 간 코인 입출금은 금지되어 있으며, 필요시 이체 작업이 가능합니다.',
    Type: '유형',
    Startt: '시작 시간',
    EndTime: '종료 시간',
    QUERY: '조회',
    Amount: '수량',
    Balance: '밸런스',
    Time: '시간',
    Status: '시간',
    Commissions: '커미션',
    Blockchainid: '블록 체인 ID',
    Ins: '종류',
    TotalValue: '총 가치',
    newcurrency: '새 화폐 가입',
    Tokeninformation: '토큰 정보',
    Day: '일',
    Dsubscriptionay: '귀하의 가입',
    Pleaseonay: '통장을 입력하십시오',
    availablebalance: '이용가능잔액',
    All: '모든',
    SUBMIT: '제출',
    SUWelcomeBMIT: '다시 오신 것을 환영합니다. 사용자 정보를 입력하십시오',
    Account: '계정',
    Password: '암호',
    ForgetPassword: '비밀번호 분실',
    notForaccount: '계정 없음',
    Signnow: '지금 신청',
    Welcomejois: '가입을 환영합니다',
    Phone: '전화',
    Email: '사서함',
    Nationality: '시민권 국가',
    LoginPassword: '로그인 비밀번호',
    ConfirmPassword: '로그인 비밀번호 확인',
    VerificationCode: '확인 코드',
    InvitationCode: '초대 코드',
    Ihavereae: '나는 이미 읽은 적이 있다',
    Useragreement: '사용자 프로토콜',
    Existingaccount: '현재 계정',
    Loginimmediately: '지금 로그인',
    BasicInformation: '기본 정보',
    MyAccount: '내 계정',
    Nickname: '별명',
    Change: '수정',
    UserID: '사용자 ID',
    FundPassword: '펀드 비밀번호',
    FResetssword: '암호 초기화',
    Noteoriginal: '주:초기화되면 원래의 펀드 비밀번호가 지워지고 새로운 비밀번호가 거래에 사용될 수 있습니다',
    DoubleAuthentication: '2 단계 인증',
    Bind: '묶다',
    Edit: '편집하다',
    Verification: '검증',
    licensetype: '인증서 유형',
    name: '이름',
    licensenumber: 'ID 번호',
    PaymentAccount: '미수금',
    Add: '더하다',
    Apaymentdd: '수신 계정을 설정하지 않았습니다.',
    Delete: '삭제',
    LoginHistory: '로그인 기록',
    Loginmethod: '로그인 방법',
    IP: 'IP 주소',
    Riskdisclosurebook: '리스크 북',
    chinaz: "한국어",
    LatestNews: "최신 뉴스",
    updatesnse: "실시간 갱신하고, 1차 정보, 1시간 해석",
    Curency: "머니",
    Curplatformency: "세계 최고의 종합 거래 플랫폼",
    digitalency: "안전,공평,투명 한 환경 에서 거래 차익 계약",
    coinsency: "거래 차익 계약 의 최 적 장소.",
    coIntegrationency: "금융과 기술의 통합",
    basictionency: "강력한 기본 금융 및 트랜잭션 인프라, 다중 계층 및 다중 클러스터 시스템 아키텍처를 채택하여 시스템, AI 기술 및 마이크로 서비스 분할 설계 및 애플리케이션의 보안 및 안정성을 크게 향상시키고 트랜잭션 안전 계수를 지능적으로 향상시킵니다.",
    bandency: "빠르고 간결한 거래 플랫폼",
    basystemcy: "메가 비트 메모리 매칭 시스템, 정확하고 빠른 트랜잭션 주문 실행, 코어 트랜잭션의 낮은 지연 시간",
    eliteemcy: "전문 엘리트 팀",
    capabiqlities: "최고의 블록 체인, 금융 및 AI 분야의 실무자들은 신규 및 개인화 된 비즈니스를위한 강력한 신속한 개발 능력을 갖춘 전문 팀을 구성하고 7 * 24 시간의 다국어 고객 서비스 지원을 제공합니다.",
    fairities: "안전하고 공정하며 투명한 거래 환경",
    regulatoryties: "여러 국가의 금융 규제 라이센스를 보유하고 미국 재무부의 디지털 비율 거래 라이센스를 획득합니다.",
    CFDtrading: 'CFD 거래',
    CFDtmajorng: '상대적으로 낮은 마진 및 수수료로 암호 화폐와 같은 주요 활성 시장 및 품종 거래',
    ICOransaction: 'ICO 환전 거래',
    Supportmajorng: '세계 주류 암호 화폐의 환전 거래 지원',
    OTCansaction: '장외 거래',
    otcajorng: '주류 암호 화폐로 외화 교환 지원',
    Blockchnsaction: '블록 체인 지갑',
    Blockchjorng: '블록 체인 탈 중앙화 기술을 사용하여 자산의 안전한 관리와 편리한 유통을 실현',
    Beginorng: 'VMISL 쇼핑몰을 이용했죠.',
    LetBeginorng: '거래를 좀 더 안도하게하다',
    LOpeninorng: '계좌를 개설하다',
    stableorng: '빠르고 안정적인 거래플랫폼',
    sPlcgGObleorng: 'VMtrade 일반 투자자를 선호하여',
    sPSimpleeorng: '간단하고 빠르며 사용하기 쉬운 플랫폼으로 모든 품종들을 만나보실 수 있습니다.VMtrade는 인터넷 기반의 응용 프로그램으로 PC 단이나 이동 상단의 웹 로그인 거래에 적합하다.',
    ssuitableng: 'VMtrade는 모든 투자자에게 적합합니다.',
    pWerovide: '어디서든 PC나 모바일 기기에서 다운로드 및 설치할 수 있는 플랫폼이 제공됩니다.',
    accountide: '계정을 선택하고 신청서를 제출합니다',
    cardInvest: '직불카드나 카드 이체를 통해 빠르고 안전하게 돈을 이체할 수 있다.',
    Accesswr: '차익 계약 등 거래 품목 과 거래 방식 을 방문 하 다.',
    Acinvestmentsswr: '당신의 투자 가치는 오를 수도 있고 떨어질 수도 있습니다.보증금거래에서는 손실이 보증금 또는 원금의 많은 부분을 초과할 수도 있다.높은 지렛대는 고위험 험을 의미한다. 당신은 당신의 위험 감당 능력과 지렛대 거래에 대한 이해 정도를 잘 생각해야 한다.',
    Arealizetsswr: '리스크는 거래 리스크뿐만 아니라, 인터넷 중단, 정치 불안정, 해킹 등 불가항력적인 요소로 인한 위험도 포함된다는 것을 알아야 합니다.',
    Parklifetsswr: 'VMISL(China Vision Capital(Hong Kong) Limited)은 SFC증권 및 선물사무감사위원회의 감독을 받고, 지명번호 BI154를 가지고 링크를 조회한다.https://apps.sfc.hk/publicregWeb/searchByName?locale=zh',
    drtwebfetsswr: '본 사이트는 범세계적 범위 내에서 접속 가능하며, 사이트의 모든 정보를 참고로 제공할 뿐 누구의 근거나 사이트의 정보에 의거하고 어떠한 작위나 부작위로 인한 결과에 대하여 어떠한 책임도 지지 않습니다.',
    webfetsswr: 'APP를 다운로드하면 바로 거래',
    home: '첫 페이지',


    // 东盛新增
    selectsown: '다운로드 방법 을 선택 하 십시오', 
    downffgdr: '로 컬 다운로드',    
    downfsafgdr: '스 캔 다운로드',
    Qualification:'자질',
    licenseTitle:'SFC증권 및 선물사무감사위원회의 감독을 받다',
    licenseNumber:'지명 번호',
    licenseLink:'링크 조회',
    homeTheMost:'가장 신뢰 받 는 금융 파생 제품 거래 플랫폼',
    viewCertificate:'인증서 보기',

}


// WEBPACK FOOTER //
// ./src/common/lang/kn.js